import { ChainID, FLARE_TESTNETS, TAC_TESTNETS } from '@ankr.com/chains-list';

import { ChainGroupID } from '../types';
import { getGroupById } from './getGroupById';

const { C_CHAIN, FALLBACK, JSON_RPC, NERVOS_CKB, NERVOS_GW, P_CHAIN, X_CHAIN } =
  ChainGroupID;

const exceptions = [C_CHAIN, JSON_RPC, NERVOS_CKB, NERVOS_GW, P_CHAIN, X_CHAIN];

export const filterChainIdsByGroup = (
  chainIds: ChainID[],
  groupId: ChainGroupID,
  withExceptions?: boolean,
) => {
  // it's shity hack because of unexpected FLARE testnets dependencies and grouping
  if (FLARE_TESTNETS.includes(groupId as unknown as ChainID)) {
    return [groupId] as unknown as ChainID[];
  }

  // it's shity hack because of unexpected TAC testnets dependencies and grouping
  if (TAC_TESTNETS.includes(groupId as unknown as ChainID)) {
    return [groupId] as unknown as ChainID[];
  }

  const group = getGroupById(groupId);

  const withoutProcessing =
    groupId === FALLBACK || (withExceptions && exceptions.includes(groupId));

  return withoutProcessing
    ? chainIds
    : chainIds.filter(id => group?.chains.includes(id));
};
